import React from "react";
import styles from "../RulesTable.module.scss";
import { Counterparty } from "../../../../common/types/counterparty";
import { TransactionRuleConditions } from "../../../transactionRules/TransactionRuleConditions";
import { TransactionRuleActions } from "../../../transactionRules/TransactionRuleActions";
import { TransactionRule } from "../../../../common/types/transactionRule";

interface RuleOverlayProps {
    rule: TransactionRule;
    counterparties: Counterparty[];
}

export const RuleOverlay: React.FC<RuleOverlayProps> = ({
    rule,
    counterparties,
}) => (
    <table>
        <thead style={{ display: "none" }}>
            <tr>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr className={styles.ruleOverlayRow}>
                <td>
                    <TransactionRuleConditions
                        rule={rule}
                        counterparties={counterparties}
                    />
                </td>
                <td>
                    <TransactionRuleActions rule={rule} />
                </td>
            </tr>
        </tbody>
    </table>
);
